module.exports = __webpack_public_path__ + "img/icon_2_43.d18be513.png";